'use client'
/***
 *
 * @file components/Typography/index.tsx
 * @description Typography component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Ingka Centres
 * @since 13 Feb 2024
 *
 */

import React, { Component, ReactNode, useState } from "react";
// import "./Typography.scss";
import classNames from "classnames";
import { StyledH1, StyledH2, StyledH3, StyledH4, StyledH5, StyledH6, StyledPaharagraph } from "@/shared/StyledComponents";
// import { useContentfulInspectorMode, useContentfulLiveUpdates } from "@contentful/live-preview/react";


/**
 * Description: a functional component that renders headings and text
 * @param param0 object containing id and data
 * @example Parameter breakup
 * ```
 *  param0: {
 *    id: "",
 *    data: {}          // data object containing children to be rendered      
 *  }
 * @returns 
 */

const Typography = ({ id = "typography", component="h5", typeid="", data }: {id?: string | undefined, component?: string, typeid?: string, data: any}) => {
  const elData = data; //useContentfulLiveUpdates(data);
  // const inspectorModeProps = useContentfulInspectorMode();

  const [struct, setStruct]: any = useState();

  // const Tag = component; //data?.content?.headingLevel || 'h5';

  const StyledTypography = ({children, ...props}: {children: ReactNode, id?: string | undefined, "data-testid": string, className: string, style: any}) => {
    switch(component) {
      case "h1":
        return <StyledH1 {...props}>{children}</StyledH1>
      case "h2":
        return <StyledH2 {...props}>{children}</StyledH2>
      case "h3":
        return <StyledH3 {...props}>{children}</StyledH3>
      case "h4":
        return <StyledH4 {...props}>{children}</StyledH4>
      case "h5":
        return <StyledH5 {...props}>{children}</StyledH5>
      case "h6":
        return <StyledH6 {...props}>{children}</StyledH6>
      default:
        return <StyledPaharagraph {...props}>{children}</StyledPaharagraph>
    }
  }

  return (
    <>
      {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
      <StyledTypography
          // {...inspectorModeProps({fieldId: elData?.contentType || "baseplateMedia", entryId: elData?.id})}
          id={elData?.content?.id || id} 
          data-testid="Typography"
          // key={`Typography-${data?.id}`}
          className={classNames(`Typography`, elData?.title || '', elData?.cssClass || '', elData?.content?.cssClass || '')}
          style={
            {
              color: elData?.content?.customStyles?.color,
              ...(elData?.content?.customStyles || {}),
              ...(elData?.content?.paddingTop || elData?.content?.paddingTop === 0 ? { paddingTop: elData?.content?.paddingTop + elData?.content?.paddingUnit || 'px' } : {}),
              ...(elData?.content?.paddingRight || elData?.content?.paddingRight === 0 ? { paddingRight: elData?.content?.paddingRight + elData?.content?.paddingUnit || 'px' } : {}),
              ...(elData?.content?.paddingBottom || elData?.content?.paddingBottom === 0 ? { paddingBottom: elData?.content?.paddingBottom + elData?.content?.paddingUnit || 'px' } : {}),
              ...(elData?.content?.paddingLeft || elData?.content?.paddingLeft === 0 ? { paddingLeft: elData?.content?.paddingLeft + elData?.content?.paddingUnit || 'px' } : {}),
              ...(elData?.content?.maxWidth || elData?.content?.maxWidth === 0 ? { maxWidth: elData?.content?.maxWidth + elData?.content?.widthUnit || 'px' } : {}),
            }
          }
        >{elData?.content?.heading || elData?.content?.text}</StyledTypography>
    </>
  )
}

export default Typography;
